import { Injectable } from '@angular/core';

import { RegionalQuickLinksConfig } from '@frontend/sports/common/client-config-data-access';
import { QuickLinkViewModel } from '@frontend/sports/types/components/quick-links';
import { DslService } from '@frontend/vanilla/core';
import { Observable, Subject, from } from 'rxjs';

import { QuickLinksSections } from './quick-links.models';

@Injectable({ providedIn: 'root' })
export class QuickLinksService {
    quickLinkClicked$ = new Subject<QuickLinkViewModel>();

    constructor(
        private regionalQuickLinks: RegionalQuickLinksConfig,
        private dslService: DslService,
    ) {}

    getQuickLinks(section: QuickLinksSections): Observable<QuickLinkViewModel[]> {
        switch (section) {
            case QuickLinksSections.BetConfirmation:
                return this.applyDslFilters(this.regionalQuickLinks.betConfirmationLinks);
            case QuickLinksSections.EmptyBetslip:
                return this.applyDslFilters(this.regionalQuickLinks.emptyBetslipLinks);
            default:
                return from([]);
        }
    }

    private applyDslFilters(quickLinks: QuickLinkViewModel[]): Observable<QuickLinkViewModel[]> {
        return this.dslService.evaluateContent(quickLinks);
    }
}
